jQuery( function ( $ ) {

  // ticker speed in px/s
  const speed = 50;

  $( '.simple-ticker' ).each( function () {
    const $list = $( '> ul', this );
    const $items = $( '> li', $list );
    const width = $list.width();
    // in ms
    const duration = Math.round( width / speed * 1000 );
    
    $items.each( function () {
      $list.append( $(this).clone().addClass( 'clone' ).attr( 'aria-hidden', 'true' ) );
    });
    $( '.clone a', $list ).attr( 'tabindex', -1 );


    $list.focusin( function ( e ) {
      const $target = $( e.target );
      const $item = $target.closest( 'li' );

      const target_transx = $item.get(0).offsetLeft * -1;
      const current_transx = ( new WebKitCSSMatrix( window.getComputedStyle( $list.get(0) ).transform ) ).m41;
      const diff_transx = target_transx - current_transx;
      const diff_transx_time = diff_transx / width * duration;
      const current_delay = parseFloat( $list.css( 'animation-delay' ) ) * 1000; // JS reads the value in seconds

      let new_delay = current_delay + diff_transx_time;
      if ( new_delay > 0 ) {
        new_delay -= duration;
      }
      new_delay %= duration;

      $list.css( 'animation-delay', `${ new_delay }ms` );
    });


    $list.css({
      animationDuration: `${ duration }ms`,
      animationPlayState: 'running',
    });

  });

});